import { ApplicationConfig, ErrorHandler, importProvidersFrom, inject, provideAppInitializer } from '@angular/core';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { APP_INITIALIZE_PROVIDER } from './core/models/appInitializeProvider';
import { AuthInterceptor } from './core/interceptors/auth.interceptor';
import { MAT_TOOLTIP_DEFAULT_OPTIONS } from '@angular/material/tooltip';
import { createErrorHandler, TraceService } from '@sentry/angular';
import { MAT_SELECT_CONFIG } from '@angular/material/select';
import { MAT_AUTOCOMPLETE_DEFAULT_OPTIONS } from '@angular/material/autocomplete';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { provideHighcharts } from 'highcharts-angular';
import { CommonModule, DatePipe } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { provideRouter, RouterModule } from '@angular/router';
import { provideAnimations } from '@angular/platform-browser/animations';
import { DependencyModule } from './core/modules/dependency.module';
import { provideTranslateService } from '@ngx-translate/core';
import { MaterialModule } from './core/modules/material.module';
import { routes } from './app.routing';

export const APP_CONFIG: ApplicationConfig = {
	providers: [
		APP_INITIALIZE_PROVIDER,
		{ provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
		{ provide: ErrorHandler, useValue: createErrorHandler() },
		provideAppInitializer(() => void inject(TraceService)),
		{ provide: MAT_TOOLTIP_DEFAULT_OPTIONS, useValue: { showDelay: 200, disableTooltipInteractivity: true } },
		{ provide: MAT_SELECT_CONFIG, useValue: { hideSingleSelectionIndicator: true } },
		{ provide: MAT_AUTOCOMPLETE_DEFAULT_OPTIONS, useValue: { hideSingleSelectionIndicator: true } },
		{ provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: { hideSingleSelectionIndicator: true } },
		provideHttpClient(withInterceptorsFromDi()),
		provideHighcharts(),
		provideAnimations(),
		provideTranslateService({
			lang: 'en',
			fallbackLang: 'en',
			loader: provideTranslateHttpLoader({
				prefix: '/locales/',
				suffix: '.json'
			})
		}),
		provideRouter(routes),
		importProvidersFrom(CommonModule, RouterModule, DependencyModule, TranslateModule, MaterialModule),
		DatePipe
	],
};